export default __webpack_public_path__ + "src/images/home/tabithathewholistic-d01db67be2b942eb60689ce67d8c4925.png";